/**
 * Created by vblanco on 28/04/2017.
 */
(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider, STATE_HELPER) {
        var base = "admin/relacion";
        var params = {
            base: base,
            baseUrl: "/" + base,
            templateUrlBase: "app/admin/relacion/relacion",
            controller: 'RelacionAdminController',
            controllerForm: 'RelacionFormAdminController',
            translateBase: "admin.relacion."
        };

        var state = STATE_HELPER(params);
        // Estado Padre
        angular.merge(state.parent, {
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_INVESTIGADOR']

            }
        });


        // Listar
        angular.merge(state.list, {
            url: '/listar/:page',
            params: {
                page: '1',
                idAutor: null,
                nombreAutor: null,
                idLugar: null,
                nombreLugar: null
            }
        });

        var resolve = {
            /* @ngInject */
            tipologias: function (Tipologia) {
                return Tipologia.findAll({sortProperty: 'nombre'}).$promise.then(function (data) {
                    return data.content;
                });
            },
            /* @ngInject */
            subgeneros: function (Subgenero) {
                return Subgenero.findAll({sortProperty: 'nombre'}).$promise.then(function (data) {
                    return data.content;
                });
            }
        };

        // Crear
        angular.merge(state.create, {
            resolve: angular.merge(resolve, {
                /* @ngInject */
                itemData: function (Relacion) {
                    return new Relacion();
                }
            })
        });
        // Editar
        angular.merge(state.edit, {
            resolve: angular.merge(resolve, {
                /* @ngInject */
                itemData: function (Relacion, $stateParams) {
                    return Relacion.get({id: $stateParams.id}).$promise;
                }
            })
        });

        // Se definen los estados
        $stateProvider
            .state(params.base, state.parent)
            .state(state.list.name, state.list)
            .state(state.create.name, state.create)
            .state(state.edit.name, state.edit);
    }
})();
